
import messageController from './MessageController'

let defaultOptions = {
  top: '24px',
  duration: 1.5
}

export default {
  config (options) {
    defaultOptions = Object.assign({}, defaultOptions, options)
  },
  info (options) {
    return this.message('info', options)
  },
  success (options) {
    return this.message('success', options)
  },
  warning (options) {
    return this.message('warning', options)
  },
  error (options) {
    return this.message('error', options)
  },
  loading (options) {
    return this.message('loading', options)
  },
  toast (options) {
    options.transitionName = 'fade-in'
    options.single = true
    return this.message('toast', options)
  },
  message (type, options) {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.duration = options.duration === 0 ? options.duration : options.duration || defaultOptions.duration
    options.top = type === 'toast' ? '48%' : options.top || defaultOptions.top
    options['type'] = type
    return new Promise((resolve, reject) => {
      let resObj = messageController.push(options)
      let close = (function () {
        return function () {
          resObj.eventBus.$messageInstance.close(resObj.name)
        }
      })()

      resolve(
        {close}
      )
    })
  },
  destory () {
    messageController.event.$messageInstance.clear()
    setTimeout(() => {
      messageController.destory()
    }, 300)
  }
}

